var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFmhTwitter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5Z",
    fill: "#045694"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0782 17.5387C14.735 17.5387 17.2812 13.68 17.2812 10.3357C17.2812 10.2255 17.2812 10.1152 17.276 10.0102C17.7695 9.65323 18.2 9.20698 18.5412 8.69773C18.0897 8.89723 17.6015 9.03373 17.087 9.09673C17.612 8.78173 18.011 8.28823 18.2 7.69498C17.7117 7.98373 17.171 8.19373 16.5935 8.30923C16.1315 7.81573 15.4752 7.51123 14.7455 7.51123C13.349 7.51123 12.215 8.64523 12.215 10.0417C12.215 10.2412 12.236 10.4355 12.2832 10.6192C10.178 10.5142 8.31424 9.50623 7.06474 7.97323C6.84949 8.34598 6.72349 8.78173 6.72349 9.24373C6.72349 10.1205 7.16974 10.8975 7.85224 11.349C7.43749 11.3385 7.04899 11.223 6.70773 11.034C6.70773 11.0445 6.70773 11.055 6.70773 11.0655C6.70773 12.294 7.57924 13.3125 8.73949 13.5487C8.52949 13.6065 8.30374 13.638 8.07274 13.638C7.90999 13.638 7.75249 13.6222 7.59499 13.5907C7.91524 14.5987 8.84974 15.3285 9.95749 15.3495C9.09124 16.0267 7.99924 16.431 6.81274 16.431C6.60798 16.431 6.40848 16.4205 6.20898 16.3942C7.31674 17.1187 8.65024 17.5387 10.0782 17.5387Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFmhTwitter);
export default __webpack_public_path__ + "static/media/fmh-twitter.6a79faf96ed79af62bf8c6635f8d32f2.svg";
export { ForwardRef as ReactComponent };